import { useState } from "react";
import { Button } from "antd";
import "./recordComplexWithAssign.css";
import { mainCategoryOptions as categories } from "../../data/data";

import { ReactComponent as NonCompliantIcon } from "../../assets/non-compliant.svg";
import { ReactComponent as CompliantIcon } from "../../assets/compliant.svg";
import { ReactComponent as PartiallyCompliantIcon } from "../../assets/partially-compliant.svg";
import { ReactComponent as PendingAssessmentIcon } from "../../assets/pending-assessment.svg";
import { ReactComponent as NATag } from "../../assets/na-tag.svg";

import DateShow from "../dateShow/DateShow";

import { format, parseISO } from "date-fns";

import { useSelector, useDispatch } from "react-redux";
import { Tooltip as AntTooltip, Select as AntSelect } from "antd";

import { assignUser } from "../../store/obligations/actions";
// import { sendEmail } from "../../store/email/actions";
import { renderOptions } from "../../util/basicRenders";
// import { assignToUserMessage } from "../../util/emailTemplates";
import { useNavigate } from "react-router-dom";

const RecordComplexWithAssign = ({ type, obligation, users }) => {
  const dispatchito = useDispatch();
  //use user authentication hook to get the user object (dpo user in this case)
  const user = useSelector(state => state.user);
  const laws = useSelector(state => state.laws.laws);
  const organization = useSelector(state => state.organizations.organizationId);
  const usersData = useSelector(state => state.organizations.usersData);
  const navigate = useNavigate();

  //get the active company from the context

  //create the login link
  const loginLink = `http://${process.env.REACT_APP_FILE_HOST}/regcom/login`;

  const [selectedOption, setSelectedOption] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  //handlers
  const handleInputChange = selectedOption => {
    // console.debug("selectedOption", selectedOption);
    setSearchValue(""); //reset search value
    setSelectedOption(selectedOption);
  };

  // Filter `option.label` match the user type `input`
  const filterOption = (input, option) =>
    (option?.label ?? "").toLowerCase().includes(input.toLowerCase()) ||
    (option?.email ?? "").toLowerCase().includes(input.toLowerCase());

  async function handleClick() {
    dispatchito(
      assignUser({
        newItem: { _id: obligation._id, user_id: selectedOption },
        user,
        organizationId: organization,
        callback: check => {
          setSelectedOption(undefined);
          // const userAssigned = usersData?.find(
          //   item => item._id === selectedOption
          // );
          // const law = laws?.find(law => law?._id === obligation?.law_id)
          // dispatchito(
          //   sendEmail({
          //     user,
          //     to: [userAssigned.email],
          //     cc: [],
          //     subject: 'Assigned Main Obligation',
          //     message: assignToUserMessage(obligation, user, false, law),
          //     isHtmlMessage: true,
          //     // message: 'HELLO text',
          //     // isHtmlMessage: false,
          //   }));
        }
      })
    );
  }

  //variable to disable the assign / reassign button if no user is selected
  const hasValue = selectedOption !== null && selectedOption !== undefined;

  // console.debug("Inside RecordComplexWithAssign user object", user);

  const renderDescription = () => {
    return (
      <AntTooltip
        title={obligation?.description}
        arrow={false}
        overlayClassName="description-tooltip"
        mouseEnterDelay={0.5}
        placement="bottomLeft"
      >
        <div className="description-with-assign-hover">
          <p
            className="description-with-assign certain-lines"
            style={{ textAlign: "left", paddingRight: "0.75rem" }}
          >
            {obligation?.description}
          </p>
        </div>
      </AntTooltip>
    );
  };

  const setID = async (value) => {
    dispatchito({
      type: "SET_NAVIGATE_ID",
      payload: { value }
    });
    user.role === "assignedUser"
      ? navigate("/my-tasks")
      : navigate("/my-checklist")
  }

  return (
    <div className="record-complex-container-with-assign">
      <div className="first-column">
        <a
          onClick={()=>setID(obligation._id)}
          // style={{ color: "#725798", textDecoration: "none" }}
          className="record-title"
        >
          <h3 style={{ textAlign: "left" }}>
            {(laws?.find(law => law._id === obligation.law_id) || {}).title}
          </h3>
        </a>
        <h5 style={{ textAlign: "left" }}>
          Article{" "}
          {obligation.article !== "undefined" ? obligation.article : "-"} /
          Paragraph{" "}
          {obligation.paragraph !== "undefined" ? obligation.paragraph : "-"}
        </h5>
        {renderDescription()}
      </div>
      <div className="second-column">
        <span style={{ width: "100%", textAlign: "left" }}>
          {
            categories.find(item => item.value === obligation?.mainCategory)
              ?.label
          }
        </span>
      </div>
      <div className="third-column">

        {obligation?.assessment === "Partially" && <PartiallyCompliantIcon />}
        {obligation?.assessment === "Compliant" && <CompliantIcon />}
        {obligation?.assessment === "Non-Compliant" && <NonCompliantIcon />}
        {obligation?.assessment === "Pending" && <PendingAssessmentIcon />}
        {obligation?.assessment === "na" && <NATag />}

      </div>
      <div className="fourth-column">
        {type === "immediate" && null}
        {type === "expire" && null}
        {type === "default" && null}
        {obligation.dueDate ? (
          <DateShow
            date={format(parseISO(obligation?.dueDate), "d-MMM-yyyy")}
          />
        ) : (
          <div>-</div>
        )}
      </div>
      <div className="fifth-column">
        <AntSelect
          className="assign-select"
          // popupClassName="custom-dropdown"
          dropdownStyle={{maxHeight:"17rem", minWidth: "20rem"}}
          virtual={false}
          placement="bottomRight"
          showSearch
          allowClear
          filterOption={false}
          onSearch={setSearchValue}
          value={users
            ?.filter(b => b._id === selectedOption)
            .map(b => `${b?.firstName} ${b?.lastName}`)}
          onChange={handleInputChange}
          placeholder={
            user.role === "corporateComplianceObserver" ||
            user.role === "groupComplianceObserver"
              ? ""
              : "Select"
          }
          disabled={
            user.role === "corporateComplianceObserver" ||
            user.role === "groupComplianceObserver"
          }
          style={{ width: "12.688rem", textAlign: "left" }}
        >
          {renderOptions(searchValue, users)}
        </AntSelect>
        <div className="second-row">
          {user.role !== "corporateComplianceObserver" &&
            user.role !== "groupComplianceObserver" && (
              <Button
                type="text"
                size="medium"
                disabled={!hasValue}
                className="assign-button-rc no-margin"
                onClick={() => {
                  handleClick();
                }}
              >
                Assign
              </Button>
            )}
        </div>
      </div>
    </div>
  );
};

export default RecordComplexWithAssign;
